import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-paper px-6 text-center">
          <div>
            <h1 className="font-display text-3xl">Une erreur est survenue</h1>
            <p className="mt-3 text-ink/60">
              Veuillez recharger la page pour continuer.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
